import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Alert, Button, Modal, Spinner } from 'react-bootstrap';
import '../styles/Telefonica.css';
import { Redirect, Switch, Route, useLocation, Link } from 'react-router-dom';
import ClickAwayListener from 'react-click-away-listener';
import useBreakpoints from '../styles/useBreakpoints';

import Sesion from '../components/Sesion';
import SubirArchivo from '../components/SubirArchivo';
// import Descargar from './Descargar';
import Copyright from '../components/Copyright';

const API_DEFAULT = 'https://back.encuestascnc.com';
// const API_DEFAULT = 'http://127.0.0.1:5000';

function Telefonica() {
    const location = useLocation();
    const point = useBreakpoints();
    const [showAlert, setShowAlert] = useState(false);
    const [showBackdrop, setShowBackdrop] = useState(false);
    const [message, setMessage] = useState('');
    const [severity, setSeverity] = useState('')
    const [pathname, setPathname] = useState(location.pathname);
    const paths = ['/inicio-sesion', '/subir-archivo'/* , '/descargar-consolidado' */];

    const [auth, setAuth] = useState(localStorage.getItem('auth'));
    const [accessToken, setAccessToken] = useState(localStorage.getItem('token'));
    const [username, setUsername] = useState(localStorage.getItem('username'));

    const login = async (user, password) => {
        setShowBackdrop(true);
        const res = await fetch(`${API_DEFAULT}/login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                'username': user,
                'password': password
            })
        })
        if (res.ok) {
            res
                .json()
                .then(d => {
                    setShowBackdrop(false);
                    localStorage.setItem('token', d['token']);
                    localStorage.setItem('auth', true);
                    localStorage.setItem('username', user);
                    setUsername(user);
                    setAccessToken(d['token']);
                    setAuth(true);
                })
        }
        else {
            setShowBackdrop(false);
            setMessage('Los datos de usuario y contraseña son incorrectos.');
            setSeverity('danger');
            setTimeout(() => { setShowAlert(true) }, 0);
        }
    }

    const validateToken = async () => {
        let ok = true;
        if (auth) {
            setShowBackdrop(true);
            const res = await fetch(`${API_DEFAULT}/validate-token`, {
                headers: { 'x-access-tokens': accessToken },
            })
            await res
                .json()
                .then(d => {
                    setShowBackdrop(false);
                    if (d['message'] !== 'token is valid') {
                        logout();
                        setMessage('La sesión a caducado, ingrese nuevamente.');
                        setSeverity('warning');
                        setTimeout(() => { setShowAlert(true) }, 0);
                        ok = false;
                    }
                });
        }

        return ok;
    }

    const capitalizeUsername = (username) => {
        let username_parts = username.split('_');
        let capitalizeUsername = ''
        for (let i = 0; i < username_parts.length; i++) {
            capitalizeUsername += username_parts[i].charAt(0).toUpperCase() + username_parts[i].slice(1).toLowerCase();
            if (i < username_parts.length - 1) {
                capitalizeUsername += ''
            }
        }

        return capitalizeUsername;
    }

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('auth');
        localStorage.removeItem('username');
        setAccessToken('');
        setAuth(false);
        setUsername('')
    }

    useEffect(() => {
        setPathname(location.pathname);
    }, [location]);

    useEffect(() => {
        if (showAlert) {
            setTimeout(() => {
                setShowAlert(false);
            }, 6000);
        }
    }, [showAlert])

    return (
        <div>
            <Navbar className='navbar-shadow' bg='dark' variant='dark'>
                <Navbar.Brand>{point !== 'xs' ? 'Aplicativo Telefónica' : 'Telefónica'}</Navbar.Brand>
                {
                    auth ?
                        <React.Fragment>
                            <Nav style={{ maxHeight: 39 }} className='mr-auto'>
                                <Link className={`nav-link${pathname === '/subir-archivo' ? ' active' : ''}`} to='/subir-archivo'>Subir</Link>
                                <Link className={`nav-link${pathname === '/descargar-consolidado' ? ' active' : ' disabled-link'}`} to='/descargar-consolidado'>Descargar</Link>
                            </Nav>
                            {
                                point !== 'xs' && point !== 'sm' ?
                                    <Navbar.Text className='navbar-text'>
                                        Registrado como: <span className='navbar-user-text'>{capitalizeUsername(username)}</span>
                                    </Navbar.Text>
                                    :
                                    null
                            }
                            <Button variant='outline-light' size='sm' onClick={() => { logout() }}>Cerrar sesión</Button>
                        </React.Fragment>
                        :
                        null
                }
            </Navbar>
            <Redirect to={auth ? (paths.slice(1).includes(pathname) ? pathname : paths[1]) : paths[0]} />
            <Switch>
                <Route exact path={paths[0]}>
                    <Sesion login={login} />
                </Route>
                <Route exact path={paths[1]}>
                    {
                        auth ?
                            <SubirArchivo
                                API_DEFAULT={API_DEFAULT}
                                setShowAlert={setShowAlert}
                                setMessage={setMessage}
                                setSeverity={setSeverity}
                                setShowBackdrop={setShowBackdrop}
                                accessToken={accessToken}
                                validateToken={validateToken}
                                logout={logout}
                            />
                            :
                            <Redirect to={paths[0]} />
                    }
                </Route>
                {/* <Route exact path={paths[2]}>
                    {
                        auth ?
                            <Descargar
                                validateToken={validateToken}
                            />
                            :
                            <Redirect to={paths[0]} />
                    }
                </Route> */}
            </Switch>
            <Modal
                centered
                show={showBackdrop}
                backdrop='static'
            >
                <Spinner animation='border' variant='light' />
            </Modal>
            <ClickAwayListener onClickAway={() => setShowAlert(false)}>
                <Alert className='alert' variant={severity} show={showAlert} onClose={() => setShowAlert(false)} dismissible>
                    {message}
                </Alert>
            </ClickAwayListener>
            <Copyright />
        </div>
    );
}

export default Telefonica;
